<template>
  <div id="app">
    <router-view></router-view>
    <login-dialog :visible="loginVisible" @close="()=>{loginVisible = false}"></login-dialog>
  </div>
</template>

<script>

import loginDialog from './components/common/login_dialog.vue'
export default {
  name: 'App',
  components:{
    loginDialog
  },
  data(){
    return {
      loginVisible:false,
    }
  },
  mounted(){
    //打开 登录弹框
    this.$bus.$on('OPEN_LOGIN_DIALOG',()=>{
      // console.log('接收到登录通知,,')
      this.loginVisible = true
    })
  },
  beforeDestroy(){
    this.$bus.$off('OPEN_LOGIN_DIALOG')
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-family: 'SourceHanSans';
  
}
*::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue